// 케이스 통합 뷰 — Firestore 조회 도우미
// 병합 규칙(정본)은 caseView.js에 있고, 이 파일은 "어디서 읽어오는가"만 담당한다.
// (caseView.js는 firebase 의존 없는 순수 모듈로 유지 — Node 비교 스크립트가 그대로 쓰기 위함)
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { caseMatchesClinic, caseInRange } from './caseView';

const statusesOf = (includeExcluded) => (includeExcluded ? ['pending', 'imported', 'excluded'] : ['pending', 'imported']);

// 목록 쿼리는 반드시 where 필터 — labId 등호 + status in (복합 인덱스 불필요)
async function fetchCases(labId, includeExcluded) {
    const snap = await getDocs(query(collection(db, 'parsedCases'),
        where('labId', '==', labId), where('status', 'in', statusesOf(includeExcluded))));
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
        .filter(r => r.sourceType !== 'scan_only');   // 스캔만 있는 폴더는 명세서·매출 대상 아님
}

/** 이 기공소·기간·거래처의 수집 케이스 */
export async function loadCasesForClinic({ labId, clinicSel, partnerName, from, to, includeExcluded = false, nfcNormalize = false }) {
    const rows = await fetchCases(labId, includeExcluded);
    return rows
        .filter(r => caseMatchesClinic(r, clinicSel, partnerName, { nfcNormalize }))
        .filter(r => caseInRange(r, from, to));
}

/** 이 기공소·기간의 수집 케이스 전체(거래처 무관) — 예상 매출·제작 현황용 */
export async function loadCasesForLab({ labId, from, to, includeExcluded = false }) {
    const rows = await fetchCases(labId, includeExcluded);
    return rows.filter(r => caseInRange(r, from, to));
}
